var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07117 1.32678C0.55957 1.46631 0.1875 1.88489 0.1875 2.39648C0.1875 14.3492 9.86133 23.9766 21.7676 23.9766C22.3257 23.9766 22.7443 23.651 22.8838 23.1394L24 18.3025C24.093 17.7909 23.8605 17.2328 23.3489 17.0002L18.1399 14.7678C17.6748 14.5818 17.1632 14.7213 16.8376 15.0934L14.5122 17.9304C10.8845 16.2096 7.95447 13.233 6.28015 9.69836L9.11719 7.37292C9.48926 7.04736 9.62878 6.53577 9.44275 6.07068L7.21033 0.861694C6.97778 0.350098 6.41968 0.0710449 5.90808 0.210571L1.07117 1.32678Z",
    fill: "#086AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.de4a504005335b968cdb3c174bdb5276.svg";
export { ForwardRef as ReactComponent };